import { DemoExample } from "@/components/sections/DemoSection";

export const skinSmoothingDemo: DemoExample = {
    label: "Skin Smoothing",
    beforeImage: "/images/demos/skin-smoothing/skin-smoothing-before.webp",
    beforeImageSrcSet: "/images/demos/skin-smoothing/skin-smoothing-before-400w.webp 400w, /images/demos/skin-smoothing/skin-smoothing-before-800w.webp 800w",
    afterImage: "/images/demos/skin-smoothing/skin-smoothing-after.webp",
    afterImageSrcSet: "/images/demos/skin-smoothing/skin-smoothing-after-400w.webp 400w, /images/demos/skin-smoothing/skin-smoothing-after-800w.webp 800w",
    title: "Smooth Skin Naturally",
    description: "Achieve natural-looking skin smoothing for portraits.",
    alt: "Before and after skin smoothing"
};

export const teethWhiteningDemo: DemoExample = {
    label: "Teeth Whitening",
    beforeImage: "/images/demos/teeth-whitening/teeth-whitening-before.webp",
    beforeImageSrcSet: "/images/demos/teeth-whitening/teeth-whitening-before-400w.webp 400w, /images/demos/teeth-whitening/teeth-whitening-before-800w.webp 800w",
    afterImage: "/images/demos/teeth-whitening/teeth-whitening-after.webp",
    afterImageSrcSet: "/images/demos/teeth-whitening/teeth-whitening-after-400w.webp 400w, /images/demos/teeth-whitening/teeth-whitening-after-800w.webp 800w",
    title: "Whiten Teeth Naturally",
    description: "Brighten smiles with natural-looking teeth whitening.",
    alt: "Before and after teeth whitening"
};

export const eyeEnhancementDemo: DemoExample = {
    label: "Eye Enhancement",
    beforeImage: "/images/demos/eye-enhancement/eye-enhancement-before.webp",
    afterImage: "/images/demos/eye-enhancement/eye-enhancement-after.webp",
    title: "Enhance Eyes",
    description: "Make eyes brighter and more vibrant.",
    alt: "Before and after eye enhancement"
};

export const strayHairRemovalDemo: DemoExample = {
    label: "Stray Hair Removal",
    beforeImage: "/images/demos/stray-hair-removal/stray-hair-removal-before.webp",
    beforeImageSrcSet: "/images/demos/stray-hair-removal/stray-hair-removal-before-400w.webp 400w, /images/demos/stray-hair-removal/stray-hair-removal-before-800w.webp 800w",
    afterImage: "/images/demos/stray-hair-removal/stray-hair-removal-after.webp",
    afterImageSrcSet: "/images/demos/stray-hair-removal/stray-hair-removal-after-400w.webp 400w, /images/demos/stray-hair-removal/stray-hair-removal-after-800w.webp 800w",
    title: "Remove Stray Hairs",
    description: "Clean up flyaway hairs for polished portrait photos.",
    alt: "Before and after stray hair removal"
};
